import React, { useEffect, useState } from "react";
import "./header.scss";
import { MdMenu } from "react-icons/md";
import {
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  ListItemIcon,
  Divider,
  Box,
  Typography,
} from "@mui/material";
import Logout from "@mui/icons-material/Logout";
import LockResetIcon from "@mui/icons-material/LockReset";
import { useNavigate } from "react-router-dom";

function Header({ trigger }) {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData") || "[]");

    if (Array.isArray(userData) && userData.length > 0 && userData[0].name) {
      setUserName(userData[0].name);
    }
  }, []);

  return (
    <div className="navbarContainer header">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid navbarContent">
          <p className="navbar-brand mb-0">
            <MdMenu fontSize={"25px"} className="menu-icon" onClick={trigger} />
          </p>
          <div
            className="collapse navbar-collapse justify-content-start"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <img
                  className="logo-image"
                  src={require("../../assets/upwardiq_logo.png")}
                  alt="UpwardIQ"
                />
              </li>
            </ul>
          </div>
          <div
            className="collapse navbar-collapse justify-content-end d-flex"
            id="navbarSupportedContent2"
          >
            <div className="">
              {/* <h6 className='navbar-lastText p-0 m-0 d-none d-lg-block'>{userName}</h6> */}
              {/* <h6 className="navbar-lastText p-0 m-0 d-none d-lg-block">
                UpwardIQ
              </h6> */}
              <Tooltip className="remove-hover" >
                <IconButton
                  className="remove-hover"
                  onClick={handleAvatarClick}
                  size="small"
                  sx={{ ml: 2 }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }} className="remove-hover" >
                    {/* <Typography
                      variant="subtitle2"
                      sx={{ color: "text.primary", fontWeight: 600, fontSize: 18 }}
                    >
                      Admin
                    </Typography> */}
                    <Avatar sx={{ width: 36, height: 36, ml: 1 }} className="remove-hover"></Avatar>
                  </Box>
                </IconButton>
              </Tooltip>

              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={()=>{
                  navigate("/reset-password")
                }}>
                  <ListItemIcon>
                    <LockResetIcon fontSize="small" />
                  </ListItemIcon>
                  Reset Password
                </MenuItem>
                <Divider />
                <MenuItem onClick={()=>{
                  localStorage.clear();
                  navigate("/login");
                }}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Header;
